// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"715":"0325aa37","843":"63b0a9f1"}[chunkId] + ".chunk.css";
};